function copyToClipboard(element) {
  var text = element.parent().find('.card-file__license').text();
  var $temp = $("<input>");
  $body.append($temp);
  $temp.val(text).select();
  document.execCommand("copy");
  $temp.remove();
}

function init() {
  if ($('.card-file__copy').length > 0) {
    $('.card-file__copy').click(function () {
        copyToClipboard($(this));
    });
  }
}
$(function() {
  init();
});